<template>
    <div style="height:100%;" v-loading="iframeLoading">
        <iframe class="lnk-frame"
                id="lnk-iframe"
                scrolling="auto"
                frameborder="0"
                style=""
                :src="src" ></iframe>
      </div>
</template>

<script>
export default {
    name: 'lnk-dms-iframe',
    data(){
        return {
            iframeLoading: false // 遮罩
        };
    },
    computed: {
        src(){
            this.iframeLoading = true;
            if(this.$route.params.src){
                const urlRegExp = /http(s)?:\/\/+(\/[.\/?%&=]*)?/i; // 判断是否url正则表达式
                if(this.$route.params.src.startsWith(appCtx.cdnPath)){ // 由页面调用gotoContentPage后跳转的路径
                    return `${this.$route.params.src}`;
                }else if(urlRegExp.test(this.$route.params.src)){
                    return `${this.$route.params.src}`; // 完整url路径
                }else{
                    return `${appCtx.cdnPath}${this.$route.params.src}`; // 由菜单进入
                }
            }else{
                return '';
            }
        }
    }
};
</script>

<style scoped>
.lnk-frame{
    width: 100%;
    height: calc(100% - 10px);
    padding:0px;
    background-color: rgba(216,220,228,1);
}
</style>
